module.exports = __webpack_public_path__ + "img/DE00296.97cc4b8e.svg";